import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import BlogRollPostItem, { IBlogRollPostItemProps } from './BlogRollPostItem';

export interface IBlogRollPostsProps extends IBaseElementProps {
	heading?: string;
	posts: IBlogRollPostItemProps[];
	viewAllLink?: ILink;
}

/**
 * Blog Roll Posts
 * @block
 * @requiresHooks
 * @icon format-gallery
 */
const BlogRollPosts: React.FC<IBlogRollPostsProps> = ({
	className,
	classNames = [],
	heading,
	posts = [],
	viewAllLink,
}) => {
	if (!Array.isArray(posts)) {
		return null;
	}

	return (
		<div className={className || cn('blogroll-posts', ...classNames)}>
			{heading && <h2 className="blogroll-posts__heading">{heading}</h2>}
			<div className="blogroll-posts__inner">
				{posts.map((post, index) => (
					<BlogRollPostItem {...post} key={index} />
				))}
			</div>

			{viewAllLink && (
				<Button {...viewAllLink} className="blogroll-posts__view-all" />
			)}
		</div>
	);
};

export default BlogRollPosts;
